import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Link } from 'foundations-components/transitional/components/Link';
import { H2 } from 'foundations-components/transitional/components/H2';
import { useSubscription } from '../../../hooks/useSubscription';
import { TEST_IDS, URLS } from '../../../utils/constants';
import { handleError } from '../../../utils/errorHandling';
import { useTracker } from '../../../utils/usageTracker';
import { useDeleteSubscription } from './useDeleteSubscription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DeleteModal({
  objectId,
  actions,
  closeSidebar
}) {
  const {
    name
  } = useSubscription();
  const {
    trackInteraction
  } = useTracker();
  const {
    close
  } = actions;
  const onCancel = () => {
    trackInteraction('deleteSubscriptionModalClosed');
    close();
  };
  const [onSubmit, {
    loading: submitLoading
  }] = useDeleteSubscription({
    objectId,
    onClose: () => {
      close();
      closeSidebar();
    }
  });
  return /*#__PURE__*/_jsxs(Modal, {
    use: "danger",
    "data-test-id": TEST_IDS.Delete,
    size: "auto",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.DeleteSubscriptionModal.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "subscriptions.DeleteSubscriptionModal.description_jsx",
        options: {
          subscriptionName: name,
          href: URLS.KBDeleteSubscription,
          external: true
        },
        elements: {
          Link
        }
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        use: "danger",
        "data-test-id": `${TEST_IDS.Delete}:submit`,
        loading: submitLoading,
        onClick: () => {
          onSubmit().catch(e => handleError(e));
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.DeleteSubscriptionModal.confirmDelete"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: onCancel,
        "data-test-id": `${TEST_IDS.Delete}:cancel`,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "common.cancel"
        })
      })]
    })]
  });
}